import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type StoreService from 'scaleflow/services/store';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';

class ScansRoute extends Route {
  @service declare store: StoreService;
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;

  model() {
    return this.store.findAll('scan', { reload: true });
  }

  afterModel() {
    if (!this.betaToggle.isXrayCustomer) this.router.transitionTo('home');
  }
}

export default instrumentRoutePerformance(ScansRoute);
